// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  margin: 0;
  font-family: lato;
  height: 100%;
  -webkit-overflow-scrolling: touch;
}
html *,
body * {
  outline: none;
  --mat-stepper-container-text-font: "Lato";
  --mat-expansion-container-text-color: var(--text);
  --mat-stepper-header-selected-state-icon-foreground-color: #fff;
  --mat-stepper-header-selected-state-label-text-color: var(--text);
  --mat-stepper-header-selected-state-icon-background-color: var(--primary);
  --mat-stepper-header-icon-background-color: #0000008a;
  --mat-stepper-header-icon-foreground-color: #fff;
  --mat-stepper-header-label-text-color: rgba(0, 0, 0, 0.54);
  --mdc-filled-text-field-label-text-color: rgba(0, 0, 0, 0.42);
  --mdc-filled-text-field-input-text-color: rgba(0, 0, 0, 0.42);
  --mdc-filled-text-field-error-label-text-color: var(--danger);
  --mat-sys-on-error-container: var(--danger);
  --mdc-filled-text-field-hover-label-text-color: rgba(0, 0, 0, 0.42);
  --mdc-filled-text-field-error-hover-label-text-color: rgba(0, 0, 0, 0.42);
  --mdc-filled-text-field-input-text-placeholder-color: rgba(0, 0, 0, 0.42);
  --md-sys-typescale-body-medium-font-size: 14px;
  --md-sys-typescale-label-large-font-size: 14px;
  --mdc-text-button-hover-state-layer-color: var(--primary-hover);
  --mat-text-button-pressed-state-layer-opacity: 0.1;
  --mat-text-button-hover-state-layer-opacity:0.1;
  --mat-expansion-container-shape: 4px;
  --mat-sys-body-medium-size: 14px !important;
  --mat-expansion-container-text-size: 14px !important;
}

body::-webkit-scrollbar,
.mat-mdc-select-panel::-webkit-scrollbar,
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  -webkit-transition: height 0.15s ease-out;
  transition: height 0.15s ease-out;
}

body::-webkit-scrollbar-track,
.mat-mdc-select-panel::-webkit-scrollbar-track,
::-webkit-scrollbar-track {
  border-radius: 10px;
}

body::-webkit-scrollbar-thumb,
.mat-mdc-select-panel::-webkit-scrollbar-thumb,
::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  opacity: 0.1;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.3);
  box-shadow: rgba(255, 255, 255, 0.3) 0 0 0 1px;
}

body:hover::-webkit-scrollbar,
.mat-mdc-select-panel:hover::-webkit-scrollbar {
  height: 0.6em;
  -webkit-transition: height 0.25s ease-in;
  transition: height 0.25s ease-in;
}

body:hover::-webkit-scrollbar-thumb,
.mat-mdc-select-panel:hover::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.3);
  box-shadow: rgba(255, 255, 255, 0.3) 0 0 0 1px;
}

body::-webkit-scrollbar-thumb:hover,
.mat-mdc-select-panel::-webkit-scrollbar-thumb:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.55);
}

footer small {
  font-size: 0.7rem;
  text-transform: uppercase;
}

.overflow-hidden {
  overflow: hidden;
}

.resize .border {
  position: absolute;
  background: red;
}

.resize .border-top,
.resize .border-bottom {
  left: 0;
  right: 0;
  height: 1px;
  cursor: n-resize;
}

.resize .border-left,
.resize .border-right {
  top: 0;
  bottom: 0;
  width: 1px;
  cursor: w-resize;
}

.resize .border-left {
  left: 0;
}

.resize .border-right {
  right: 0;
}

.resize .border-top {
  top: 0;
}

.resize .border-bottom {
  bottom: 0;
}

.resize .border-top-left {
  left: 0;
  top: 0;
  height: 4px;
  width: 4px;
  background: transparent !important;
  cursor: se-resize;
  z-index: 999;
}

.resize .border-top-right {
  right: 0;
  top: 0;
  height: 4px;
  width: 4px;
  background: transparent !important;
  cursor: ne-resize;
  z-index: 999;
}

.resize .border-bottom-left {
  left: 0;
  bottom: 0;
  height: 4px;
  width: 4px;
  background: transparent !important;
  cursor: ne-resize;
  z-index: 999;
}

.resize .border-bottom-right {
  right: 0;
  bottom: 0;
  height: 4px;
  width: 4px;
  background: transparent !important;
  cursor: se-resize;
  z-index: 999;
}

.cdk-global-overlay-wrapper {
  position: absolute;
  top: 0;
  left: 0;
}

.export-modal-container {
  max-width: 85vw !important;
}
.export-modal-container .mat-mdc-mdc-dialog-container {
  padding: 0px !important;
  overflow: hidden;
}

ngx-daterangepicker-material .md-drppicker {
  padding: 10px !important;
  font-family: var(--font-family) !important;
  font-size: 1em !important;
  max-width: 640px;
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
ngx-daterangepicker-material .md-drppicker td.active, ngx-daterangepicker-material .md-drppicker .md-drppicker td.active:hover {
  background-color: var(--primary) !important;
}
ngx-daterangepicker-material .md-drppicker .table-condensed {
  border-spacing: 0px;
}
ngx-daterangepicker-material .md-drppicker th.month {
  text-transform: uppercase;
  color: var(--text);
  font-size: 14px;
}
ngx-daterangepicker-material .md-drppicker.double .calendar {
  max-width: 295px !important;
}
ngx-daterangepicker-material .md-drppicker.double .calendar th.available.prev,
ngx-daterangepicker-material .md-drppicker.double .calendar th.available.next {
  background: none;
  position: relative;
  vertical-align: middle;
  line-height: 30px;
}
ngx-daterangepicker-material .md-drppicker.double .calendar th.available.prev::before,
ngx-daterangepicker-material .md-drppicker.double .calendar th.available.next::before {
  font-family: "Font Awesome 5 Free";
  content: "\\f104";
  position: absolute;
  color: var(--primary);
  vertical-align: middle;
  top: 50%;
  transform: translateY(-50%);
  height: 100%;
  font-size: 1.3em;
  text-align: center;
}
ngx-daterangepicker-material .md-drppicker.double .calendar.left {
  border-right: 1px solid var(--line);
}
ngx-daterangepicker-material .md-drppicker.double .calendar td,
ngx-daterangepicker-material .md-drppicker.double .calendar th {
  border-radius: 0px !important;
  min-width: 40px;
  height: 30px;
}
ngx-daterangepicker-material .md-drppicker.double .calendar td span {
  padding: 0px;
  color: inherit;
  font-size: 13px;
  font-weight: 550 !important;
}
ngx-daterangepicker-material .md-drppicker.double .calendar td.available:not(.active):hover {
  background-color: rgba(var(--primary-rgb), 0.2) !important;
}
ngx-daterangepicker-material .md-drppicker.double .calendar td.available:not(.off) {
  color: var(--text);
}
ngx-daterangepicker-material .md-drppicker.double .calendar td::hover {
  border-radius: 0px !important;
}
ngx-daterangepicker-material .md-drppicker.double .calendar td.in-range {
  background-color: rgba(var(--primary-rgb), 0.2) !important;
  border-radius: 0px !important;
  color: var(--text) !important;
}
ngx-daterangepicker-material .md-drppicker.double .calendar td.active {
  background-color: var(--primary) !important;
  border-radius: 0px !important;
  color: var(--white-color) !important;
}
ngx-daterangepicker-material .md-drppicker.double .calendar th span {
  padding: 0px;
}
ngx-daterangepicker-material .md-drppicker.double .calendar th.available:not(.active):not(.prev):not(.next):hover {
  background-color: rgba(var(--primary-rgb), 0.2) !important;
}
ngx-daterangepicker-material .md-drppicker.double .calendar th::hover {
  border-radius: 0px !important;
}
ngx-daterangepicker-material .md-drppicker .start-date,
ngx-daterangepicker-material .md-drppicker .end-date,
ngx-daterangepicker-material .md-drppicker .in-range {
  color: var(--white-color) !important;
}
ngx-daterangepicker-material .md-drppicker .start-date span,
ngx-daterangepicker-material .md-drppicker .end-date span,
ngx-daterangepicker-material .md-drppicker .in-range span {
  opacity: 1 !important;
}
ngx-daterangepicker-material .md-drppicker .btn {
  color: var(--primary) !important;
  box-shadow: none !important;
  background: transparent !important;
  margin: 0;
  min-width: auto;
  line-height: 25px !important;
  width: 80px;
}
ngx-daterangepicker-material .md-drppicker .btn.btn-default::after {
  content: "|";
  color: gray;
  font-size: 19px;
  line-height: 0px;
  margin-left: 13px;
  position: relative;
  top: -1px;
}
ngx-daterangepicker-material .md-drppicker .ranges {
  order: 3;
  float: none;
  flex: 1 0 100%;
  display: flex;
}
ngx-daterangepicker-material .md-drppicker .ranges ul {
  margin: 7px 0;
}
ngx-daterangepicker-material .md-drppicker .ranges ul li:first-child::before {
  color: var(--text);
}
ngx-daterangepicker-material .md-drppicker .ranges ul li {
  margin: 0px 5px;
  display: inline-block;
}
ngx-daterangepicker-material .md-drppicker .ranges ul li:hover {
  background: transparent;
  border-radius: 16px;
}
ngx-daterangepicker-material .md-drppicker .ranges ul li button {
  padding: 6px 10px;
  background: #f2f2f2;
  border-radius: 16px;
  color: #333;
  font-size: 12px;
}
ngx-daterangepicker-material .md-drppicker .ranges ul li button.active {
  background-color: var(--primary);
}
ngx-daterangepicker-material .md-drppicker .ranges ul li:first-child {
  padding-left: 75px;
  vertical-align: middle;
  position: relative;
}
ngx-daterangepicker-material .md-drppicker .ranges ul li:first-child::before {
  content: "Quick Select";
  display: block;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
ngx-daterangepicker-material .md-drppicker .calendar.left,
ngx-daterangepicker-material .md-drppicker .calendar.right {
  order: 1;
}
ngx-daterangepicker-material .md-drppicker .buttons {
  order: 4;
  flex: 1 0 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
ngx-daterangepicker-material .md-drppicker .btn {
  line-height: 24px !important;
  cursor: pointer;
}
ngx-daterangepicker-material .md-drppicker .btn.clear svg {
  width: 16px;
  height: 16px;
}
ngx-daterangepicker-material .md-drppicker .btn:hover {
  background-color: rgba(var(--primary-rgb), 0.1) !important;
}
ngx-daterangepicker-material .md-drppicker.double .calendar td.active {
  background-color: var(--primary) !important;
  border-radius: 0px !important;
  color: #fff !important;
}
ngx-daterangepicker-material .md-drppicker.double .calendar td.active.off {
  background-color: #fff !important;
  border-color: transparent !important;
  color: #999 !important;
}

.mat-mdc-form-field.mat-mdc-focused .mat-mdc-select-arrow {
  transform: rotate(-135deg) !important;
}

.mat-mdc-select-search-clear {
  top: 10px;
  background: transparent;
  border: none;
  line-height: 24px;
}

.mat-mdc-select-panel {
  position: absolute;
  top: 5px;
  left: 0px;
  font-size: 13px;
  font-weight: 400;
  border-radius: 3px !important;
  border-top-style: none;
}

.mat-mdc-form-field-appearance-outline .mat-mdc-form-field-outline-start {
  border-radius: 0px !important;
  border-right-style: none !important;
}

.mat-mdc-form-field-appearance-outline .mat-mdc-form-field-outline-end {
  border-radius: 0px !important;
  border-left-style: none !important;
}

.mat-mdc-select-panel ng-animating {
  visibility: hidden;
}

.mat-mdc-select-search-panel .mat-mdc-option {
  height: 30px !important;
  line-height: 30px !important;
}

.sort-order-dialog .mat-mdc-mdc-dialog-container {
  padding: 0 !important;
  overflow: unset !important;
}

.select-dropdown mat-form-field .mat-mdc-form-field-wrapper {
  padding-bottom: 0 !important;
}
.select-dropdown mat-form-field .mat-mdc-form-field-infix {
  border-top: none !important;
}
.select-dropdown mat-form-field .mat-mdc-form-field-ripple {
  background-color: var(--primary);
  height: 1px;
}
.select-dropdown mat-form-field .mat-mdc-form-field-underline {
  bottom: 0.25em !important;
}
.select-dropdown mat-form-field .cross-icon {
  font-size: 14px !important;
  color: rgba(0, 0, 0, 0.54);
}
.select-dropdown .mat-mdc-select-panel {
  font-size: 13px;
  font-weight: 400;
  border-radius: 3px !important;
  border-top-style: none;
}
.select-dropdown .mat-mdc-select-placeholder {
  color: rgba(0, 0, 0, 0.87);
}
.select-dropdown .mat-mdc-form-field-appearance-outline .mat-mdc-form-field-outline-start {
  border-radius: 0px !important;
  border-right-style: none !important;
}
.select-dropdown .mat-mdc-form-field-appearance-outline .mat-mdc-form-field-outline-end {
  border-radius: 0px !important;
  border-left-style: none !important;
}
.select-dropdown .mat-mdc-select-panel ng-animating {
  visibility: hidden;
}
.select-dropdown .mat-mdc-option {
  min-height: 30px !important;
  height: 30px !important;
}

/* You can add global styles to this file, and also import other style files */
html,
body {
  height: 100%;
  font-family: "Lato", sans-serif;
}

body {
  margin: 0;
}

.content {
  position: relative;
}

.line {
  stroke-width: 1px;
}

/*********************** Common CSS *********************/
.text-light {
  color: rgba(51, 51, 51, 0.6);
}

.text-uppercase {
  text-transform: uppercase;
}

.capitalize {
  text-transform: capitalize;
}

.pulse {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  height: 14px;
  width: 14px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: 9px 0px 0px -8px;
  transform: rotateX(55deg);
  z-index: -2;
}
.pulse:after {
  content: "";
  border-radius: 50%;
  height: 40px;
  width: 40px;
  position: absolute;
  margin: -13px 0 0 -13px;
  animation: pulsate 1s ease-out;
  animation-iteration-count: infinite;
  opacity: 0;
  box-shadow: 0 0 1px 2px #89849b;
  animation-delay: 1.1s;
}

@keyframes pulsate {
  0% {
    transform: scale(0.1, 0.1);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(1.2, 1.2);
    opacity: 0;
  }
}
@keyframes bounce {
  0% {
    opacity: 0;
    transform: translateY(-2000px) rotate(-45deg);
  }
  60% {
    opacity: 1;
    transform: translateY(30px) rotate(-45deg);
  }
  80% {
    transform: translateY(-10px) rotate(-45deg);
  }
  100% {
    transform: translateY(0) rotate(-45deg);
  }
}
.site-selection-dropdown-panel {
  overflow: hidden;
  background-color: var(--mat-select-panel-background-color, var(--white-color));
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.24);
  width: 376px !important;
  max-height: 360px !important;
  border-radius: 4px !important;
}

.site-selection-dropdown-sort-menu {
  position: relative !important;
  right: 162px !important;
  top: 5px !important;
  background-color: var(--white-color) !important;
  border-radius: 4px !important;
}

.site-selection-dropdown-empty {
  font-family: Lato !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 16px !important;
}

/**
 * Sets a consistent typography baseline with the Lato font and overridable size, line height, and weight.
 */
/* ==========================================================================
   Text Utilities
   ========================================================================== */
/**
 * Applies the shared icon color and opacity behavior, including a stronger hover state.
 */
.app-mat-form-field-trigger {
  width: 100%;
  cursor: pointer;
}
.app-mat-form-field-trigger .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
.app-mat-form-field-trigger .mat-mdc-text-field-wrapper .mat-mdc-select-placeholder {
  font-family: Lato !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 16px !important;
}
.app-mat-form-field-trigger .mat-mdc-select-value {
  color: #333333 !important;
}
.app-mat-form-field-trigger .mat-mdc-select-placeholder {
  color: var(--lighter-grey) !important;
}
.app-mat-form-field-trigger.mat-mdc-select-disabled .mat-mdc-select-value {
  color: rgba(0, 0, 0, 0.38);
}
.app-mat-form-field-trigger .mat-mdc-select-arrow-wrapper {
  padding-right: 3px;
}
.app-mat-form-field-trigger .mdc-text-field__input {
  cursor: pointer;
}
.app-mat-form-field-trigger .mat-mdc-form-field-infix {
  padding-top: 1px !important;
  padding-bottom: 4px !important;
  position: relative !important;
  top: 6px !important;
}
.app-mat-form-field-trigger .mat-mdc-select-arrow {
  box-sizing: border-box;
  border: none !important;
  width: auto !important;
  height: auto !important;
  margin-right: 1px;
  color: var(--primary);
  display: inline-flex !important;
  transform: none !important;
  -webkit-transform: none !important;
  align-items: center;
  justify-content: center;
}
.app-mat-form-field-trigger .mat-mdc-select-arrow svg {
  display: none !important;
}
.app-mat-form-field-trigger .mat-mdc-select-arrow::after {
  content: "\\f078";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  font-size: 12px !important;
  color: var(--primary) !important;
  text-shadow: 0.3px 0 currentColor, -0.3px 0 currentColor;
  display: inline-block;
  transform: none !important;
}
.app-mat-form-field-trigger.mat-focused .mat-mdc-select-arrow, .app-mat-form-field-trigger.mat-mdc-focused .mat-mdc-select-arrow,
.app-mat-form-field-trigger .mat-mdc-select[aria-expanded=true] .mat-mdc-select-arrow,
.app-mat-form-field-trigger .mat-select[aria-expanded=true] .mat-mdc-select-arrow,
.app-mat-form-field-trigger .mat-mdc-select-panel-open .mat-mdc-select-arrow {
  transform: none !important;
  -webkit-transform: none !important;
}
.app-mat-form-field-trigger.mat-focused .mat-mdc-select-arrow::after, .app-mat-form-field-trigger.mat-mdc-focused .mat-mdc-select-arrow::after,
.app-mat-form-field-trigger .mat-mdc-select[aria-expanded=true] .mat-mdc-select-arrow::after,
.app-mat-form-field-trigger .mat-select[aria-expanded=true] .mat-mdc-select-arrow::after,
.app-mat-form-field-trigger .mat-mdc-select-panel-open .mat-mdc-select-arrow::after {
  transform: rotate(180deg) !important;
  -webkit-transform: rotate(180deg) !important;
}
.app-mat-form-field-trigger .mat-mdc-select-panel {
  background-color: #fff !important;
  padding: 0 !important;
}
.app-mat-form-field-trigger .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix i {
  text-shadow: 0.3px 0 currentColor, -0.3px 0 currentColor;
  font-size: 12px !important;
  color: var(--primary) !important;
  position: relative !important;
  left: 6px !important;
}
.app-mat-form-field-trigger .mat-mdc-icon-button:hover:not([disabled]) {
  background-color: transparent !important;
}
.app-mat-form-field-trigger .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {
  bottom: 2px !important;
}

.app-mat-form-field-trigger-open .mat-mdc-text-field-wrapper .mdc-line-ripple::before {
  border-bottom-color: #333333 !important;
}
.app-mat-form-field-trigger-open .mat-mdc-text-field-wrapper .mdc-line-ripple::after {
  border-bottom-color: #333333 !important;
}
.app-mat-form-field-trigger-open .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {
  opacity: 1 !important;
}

.app-mat-form-search-field.mat-focused .mat-mdc-input-element::placeholder {
  color: var(--light-grey) !important;
  -webkit-text-fill-color: var(--light-grey) !important;
}

.app-mat-form-search-field .mat-mdc-form-field-infix {
  padding-top: 1px !important;
  padding-bottom: 4px !important;
  position: relative !important;
  top: 3px !important;
}
.app-mat-form-search-field .mdc-line-ripple::before {
  border-bottom-color: #B6B6B6 !important;
}
.app-mat-form-search-field.mat-focused .mdc-line-ripple::after {
  border-bottom-color: #333333 !important;
  border-bottom-width: 1px !important;
}

.app-mat-form-search-field.mat-mdc-form-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {
  opacity: 0.5 !important;
}
.app-mat-form-search-field.mat-mdc-form-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix i {
  font-size: 14px !important;
  color: var(--primary) !important;
}
.app-mat-form-search-field.mat-mdc-form-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix i:hover {
  cursor: pointer !important;
}
.app-mat-form-search-field.mat-mdc-form-field.mat-focused .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {
  opacity: 0.5;
}
.app-mat-form-search-field.mat-mdc-form-field.mat-focused .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix:hover {
  opacity: 1 !important;
}
.app-mat-form-search-field.mat-mdc-form-field .mat-mdc-form-field-icon-prefix {
  padding: 0px !important;
}

.app-select-trigger--svg-arrow .mat-mdc-select-arrow {
  width: 100%;
  height: 100%;
  border: 0 !important;
  opacity: 0.5;
  background: url("/assets/images/chevronarrow.svg") no-repeat center center/contain;
  transform: rotate(0deg) !important;
  -webkit-transform: rotate(0deg) !important;
  padding: 0 !important;
}
.app-select-trigger--svg-arrow.mat-focused .mat-mdc-select-arrow,
.app-select-trigger--svg-arrow .mat-mdc-select[aria-activedescendant] .mat-mdc-select-arrow {
  opacity: 1 !important;
  transform: rotate(180deg) !important;
  -webkit-transform: rotate(180deg) !important;
}

.app-form-field .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
.app-form-field .mat-mdc-text-field-wrapper .mat-mdc-select-placeholder {
  font-size: 14px !important;
  line-height: 16px !important;
  font-family: "Lato" !important;
}
.app-form-field.mat-focused .mat-mdc-text-field-wrapper .mat-mdc-select-placeholder {
  color: #333333 !important;
  -webkit-text-fill-color: #333333 !important;
}
.app-form-field.mat-focused .mdc-line-ripple::before,
.app-form-field.mat-focused .mdc-line-ripple::after {
  border-bottom-color: #333333 !important;
}

.app-select-panel {
  overflow: hidden;
  background-color: var(--mat-select-panel-background-color, var(--white-color));
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
  border-radius: 4px !important;
}

.app-option:hover:not(.mat-mdc-option-disabled):not(.app-option-selected), .app-option:focus:not(.mat-mdc-option-disabled), .app-option.mdc-list-item--selected:not(.mat-mdc-option-disabled) {
  background-color: var(--hover-grey) !important;
}
.app-option.mdc-list-item--selected:not(.mdc-list-item--disabled):not(.mat-mdc-option-multiple) {
  background-color: rgba(var(--primary-rgb), 0.1) !important;
}
.app-option.app-option-selected:hover {
  background-color: rgba(var(--primary-rgb), 0.1) !important;
}
.app-option .mdc-list-item__primary-text {
  width: 100%;
}

.app-checkbox {
  display: flex !important;
}
.app-checkbox .mdc-form-field > label {
  padding-left: 12px;
  font-weight: 400;
  white-space: nowrap;
  color: var(--strong-text);
}
.app-checkbox .mdc-checkbox {
  width: 14px !important;
  height: 14px !important;
  flex: 0 0 14px;
  padding: 0;
  margin-top: 0 !important;
}
.app-checkbox .mdc-checkbox .mat-mdc-checkbox-touch-target {
  width: 14px;
  height: 14px;
}
.app-checkbox .mdc-checkbox input.mdc-checkbox__native-control {
  width: 100%;
  height: 100%;
}
.app-checkbox .mdc-checkbox .mdc-checkbox__background {
  position: relative;
  top: 0;
  left: 0;
  width: 14px !important;
  height: 14px !important;
  border: 1px solid;
  border-color: var(--primary) !important;
}
.app-checkbox .mdc-checkbox .mdc-checkbox__background .mdc-checkbox__checkmark {
  top: -1px;
  left: 1px;
}
.app-checkbox .mdc-checkbox .mdc-checkbox__background .mdc-checkbox__checkmark .mdc-checkbox__checkmark-path {
  stroke-dashoffset: 6px !important;
  stroke: var(--white-color) !important;
}
.app-checkbox .mdc-checkbox .mdc-checkbox__background .mdc-checkbox__mixedmark {
  width: 75%;
  border-color: var(--white-color) !important;
}
.app-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
.app-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
.app-checkbox .mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled ~ .mdc-checkbox__background {
  background-color: var(--primary) !important;
}
.app-checkbox.mat-mdc-checkbox-checked .mdc-checkbox .mdc-checkbox__background {
  background-color: var(--primary) !important;
}

.app-radio {
  --mdc-radio-state-layer-size: 20px;
}
.app-radio .mat-internal-form-field {
  align-items: baseline !important;
  vertical-align: unset !important;
}
.app-radio .mdc-radio .mdc-radio__background {
  position: relative;
  top: 3.5px;
  left: 2px;
  height: 14px;
  width: 14px;
}
.app-radio .mdc-radio .mdc-radio__inner-circle {
  border-width: unset;
  background-color: var(--primary);
}
.app-radio .mdc-radio .mdc-radio__native-control:enabled + .mdc-radio__background .mdc-radio__outer-circle,
.app-radio .mdc-radio .mdc-radio__native-control:enabled + .mdc-radio__background .mdc-radio__inner-circle {
  border-color: var(--primary) !important;
}
.app-radio .mdc-radio .mdc-radio__native-control:enabled:focus + .mdc-radio__background .mdc-radio__outer-circle,
.app-radio .mdc-radio .mdc-radio__native-control:enabled:focus + .mdc-radio__background .mdc-radio__inner-circle,
.app-radio .mdc-radio .mdc-radio__native-control:enabled:active + .mdc-radio__background .mdc-radio__outer-circle,
.app-radio .mdc-radio .mdc-radio__native-control:enabled:active + .mdc-radio__background .mdc-radio__inner-circle {
  border-color: var(--primary) !important;
}
.app-radio .mdc-label {
  position: relative;
  top: 2px;
  padding-left: 0;
  font-size: 12px;
  color: #333333;
}
.app-radio.mat-mdc-radio-disabled .mdc-radio__inner-circle {
  background-color: var(--mid-gray) !important;
}

.app-radio--compact .mdc-form-field {
  gap: 5px;
}
.app-radio--compact .mat-mdc-radio-touch-target {
  width: 100%;
  height: 100%;
}
.app-radio--compact .mat-radio-ripple {
  display: none !important;
}
.app-radio--compact .mdc-label {
  font-size: 14px;
  line-height: 16px;
}

.app-dropdown-mat-options {
  padding: 0px 12px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 28px;
  cursor: pointer;
}
.app-dropdown-mat-options:hover:not(.mat-mdc-option-disabled):not(.site-selection-dropdown-option-selected), .app-dropdown-mat-options:focus:not(.mat-mdc-option-disabled), .app-dropdown-mat-options.mdc-list-item--selected:not(.mat-mdc-option-disabled) {
  background-color: var(--hover-grey) !important;
}
.app-dropdown-mat-options.mdc-list-item--selected:not(.mdc-list-item--disabled):not(.mat-mdc-option-multiple) {
  background-color: rgba(var(--primary-rgb), 0.1) !important;
}
.app-dropdown-mat-options.site-selection-dropdown-option-selected:hover {
  background-color: rgba(var(--primary-rgb), 0.1) !important;
}
.app-dropdown-mat-options .mdc-list-item__primary-text {
  width: 100%;
}

.app-mat-tooltip-text {
  font-family: Lato !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 14px !important;
  padding: 10px !important;
  background-color: var(--tooltip-background-rgb) !important;
  border-radius: 4px !important;
  color: var(--white-color) !important;
}

.app-menu-item {
  min-height: 28px !important;
  font-family: Lato !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 16px !important;
}

.app-menu-item.app-menu-item:not([disabled]):hover {
  background-color: var(--hover-grey) !important;
}

html {
  overflow: hidden;
}

.center {
  text-align: center;
}

.flex {
  display: flex !important;
}

.relative {
  position: relative;
}

.hidden {
  display: none;
}

.scroll-max-400,
.scroll-max-300 {
  overflow-y: auto;
}

.scroll-max-300 {
  max-height: 300px;
}

.scroll-max-400 {
  max-height: 400px;
}

.mat-mdc-radio-button.mat-accent .mat-mdc-radio-ripple .mat-mdc-ripple-element {
  opacity: 0 !important; /*click effect color change*/
  background-color: var(--primary) !important;
}

.mat-mdc-radio-button.mat-mdc-accent .mat-mdc-radio-inner-circle {
  background-color: var(--primary) !important; /*inner circle color change*/
}

.mat-mdc-radio-button.mat-mdc-accent.mat-mdc-radio-checked .mat-mdc-radio-outer-circle {
  border-color: var(--primary) !important; /*outer ring color change*/
}

.daterangepicker {
  z-index: 1050 !important;
  display: block !important;
  opacity: 1 !important;
  visibility: visible !important;
}

.mdc-text-field {
  overflow: unset !important;
  will-change: auto !important;
}

.mat-mdc-button {
  height: 36px !important;
  --mdc-text-button-label-text-color: var(--primary);
  justify-content: flex-start !important;
}

.cdk-overlay-pane.mat-mdc-dialog-panel {
  --mat-dialog-container-max-width: 100% !important;
}

.mat-mdc-select-value-text {
  font-size: 14px;
  font-weight: 400;
  font-family: "Lato";
  color: var(--text);
  -webkit-text-fill-color: var(--text);
}

.gtranslate_wrapper {
  visibility: hidden !important;
}

.table-container {
  margin: 20px 20px 0px 20px;
  width: 98%;
  padding-bottom: 10px;
}

.table-action-container {
  margin-top: -12px;
  width: 100%;
  display: flex;
}

.paginator-box {
  width: 100%;
  text-align: right;
}

.table {
  max-height: calc(100vh - 220px);
  overflow: auto;
  border-radius: 5px;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}

.no-padding {
  padding: 0 !important;
}

.action-icon {
  color: var(--primary-light) !important;
  margin: 0 4px;
  transform: scale(0.7);
}

.action-icon.disabled {
  color: #d6d6d6 !important;
  cursor: not-allowed;
}

.action-icon.clickable:hover {
  color: rgb(226, 129, 87) !important;
  transition: 0.1s ease-in;
}

.hidden {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/styles.scss","webpack://./src/app/shared/components/table/table.styles.scss","webpack://./src/assets/css/_mixins.scss","webpack://./src/assets/css/common-material-styles.scss","webpack://./src/styles.scss","webpack://./node_modules/@angular/material/core/style/_elevation.scss"],"names":[],"mappings":"AAAA;;EAEI,SAAA;EACA,iBAAA;EACA,YAAA;EACA,iCAAA;ACCJ;ADCI;;EACI,aAAA;EACA,yCAAA;EACA,iDAAA;EACA,+DAAA;EACA,iEAAA;EACA,yEAAA;EACA,qDAAA;EACA,gDAAA;EACA,0DAAA;EACA,6DAAA;EACA,6DAAA;EACA,6DAAA;EACA,2CAAA;EACA,mEAAA;EACA,yEAAA;EACA,yEAAA;EACA,8CAAA;EACA,8CAAA;EACA,+DAAA;EACA,kDAAA;EACA,+CAAA;EACA,oCAAA;EACA,2CAAA;EACA,oDAAA;ACER;;ADEA;;;EAGI,UAAA;EACA,WAAA;EACA,yCAAA;EAAA,iCAAA;ACCJ;;ADEA;;;EAII,mBAAA;ACCJ;;ADEA;;;EAGI,2BAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,8CAAA;ACCJ;;ADEA;;EAEI,aAAA;EACA,wCAAA;EAAA,gCAAA;ACCJ;;ADEA;;EAGI,mBAAA;EACA,8BAAA;EACA,8CAAA;ACCJ;;ADEA;;EAEI,UAAA;EACA,+BAAA;ACCJ;;ADGI;EACI,iBAAA;EACA,yBAAA;ACAR;;ADIA;EACI,gBAAA;ACDJ;;ADIA;EACI,kBAAA;EACA,eAAA;ACDJ;;ADIA;;EAEI,OAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;ACDJ;;ADIA;;EAEI,MAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;ACDJ;;ADIA;EACI,OAAA;ACDJ;;ADIA;EACI,QAAA;ACDJ;;ADIA;EACI,MAAA;ACDJ;;ADIA;EACI,SAAA;ACDJ;;ADIA;EACI,OAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;EACA,kCAAA;EACA,iBAAA;EACA,YAAA;ACDJ;;ADIA;EACI,QAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;EACA,kCAAA;EACA,iBAAA;EACA,YAAA;ACDJ;;ADIA;EACI,OAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,kCAAA;EACA,iBAAA;EACA,YAAA;ACDJ;;ADIA;EACI,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,kCAAA;EACA,iBAAA;EACA,YAAA;ACDJ;;ADIA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;ACDJ;;ADOA;EACI,0BAAA;ACJJ;ADKI;EACI,uBAAA;EACA,gBAAA;ACHR;;ADSQ;EAKI,wBAAA;EACA,0CAAA;EACA,yBAAA;EACA,gBAAA;EAmIA,aAAA;EACA,cAAA;EACA,eAAA;AC5IZ;ADAY;EACI,2CAAA;ACEhB;ADMY;EACI,mBAAA;ACJhB;ADOY;EACI,yBAAA;EACA,kBAAA;EACA,eAAA;ACLhB;ADSgB;EACI,2BAAA;ACPpB;ADSoB;;EAEI,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;ACPxB;ADSwB;;EACI,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;ACN5B;ADUoB;EACI,mCAAA;ACRxB;ADWoB;;EAEI,6BAAA;EACA,eAAA;EACA,YAAA;ACTxB;ADawB;EACI,YAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;ACX5B;ADe4B;EACI,0DAAA;ACbhC;ADiBwB;EACI,kBAAA;ACf5B;ADkBwB;EACI,6BAAA;AChB5B;ADmBwB;EACI,0DAAA;EACA,6BAAA;EACA,6BAAA;ACjB5B;ADoBwB;EACI,2CAAA;EACA,6BAAA;EACA,oCAAA;AClB5B;ADuBwB;EACI,YAAA;ACrB5B;ADyB4B;EACI,0DAAA;ACvBhC;AD2BwB;EACI,6BAAA;ACzB5B;AD+BY;;;EAGI,oCAAA;AC7BhB;AD+BgB;;;EACI,qBAAA;AC3BpB;AD+BY;EACI,gCAAA;EACA,2BAAA;EACA,kCAAA;EACA,SAAA;EACA,eAAA;EACA,4BAAA;EACA,WAAA;AC7BhB;ADgCY;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AC9BhB;ADqCY;EACI,QAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;ACnChB;ADoCgB;EACI,aAAA;AClCpB;ADmCoB;EACI,kBAAA;ACjCxB;ADmCoB;EACI,eAAA;EACA,qBAAA;ACjCxB;ADmCwB;EACI,uBAAA;EACA,mBAAA;ACjC5B;ADoCwB;EACI,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AClC5B;ADoC4B;EACI,gCAAA;AClChC;ADsCwB;EACI,kBAAA;EACA,sBAAA;EACA,kBAAA;ACpC5B;ADsC4B;EACI,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;ACpChC;AD2CY;;EAEI,QAAA;ACzChB;AD4CY;EACI,QAAA;EACA,cAAA;EAEA,aAAA;EACA,yBAAA;EACA,mBAAA;AC3ChB;AD8CY;EACI,4BAAA;EACA,eAAA;AC5ChB;AD6CgB;EACI,WAAA;EACA,YAAA;AC3CpB;AD8CgB;EACI,0DAAA;AC5CpB;ADmDwB;EACI,2CAAA;EACA,6BAAA;EACA,sBAAA;ACjD5B;ADmD4B;EACI,iCAAA;EACA,oCAAA;EACA,sBAAA;ACjDhC;;AD2DA;EACI,qCAAA;ACxDJ;;AD2DA;EACI,SAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;ACxDJ;;AD2DA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,sBAAA;ACxDJ;;AD2DA;EACI,6BAAA;EACA,mCAAA;ACxDJ;;AD2DA;EACI,6BAAA;EACA,kCAAA;ACxDJ;;AD2DA;EACI,kBAAA;ACxDJ;;AD4DI;EACI,uBAAA;EACA,4BAAA;ACzDR;;AD6DA;EACI,qBAAA;EACA,0BAAA;AC1DJ;;AD+DQ;EACI,4BAAA;AC5DZ;AD+DQ;EACI,2BAAA;AC7DZ;ADgEQ;EACI,gCAAA;EACA,WAAA;AC9DZ;ADiEQ;EACI,yBAAA;AC/DZ;ADkEQ;EACI,0BAAA;EACA,0BAAA;AChEZ;ADoEI;EACI,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,sBAAA;AClER;ADsEI;EACI,0BAAA;ACpER;ADuEI;EACI,6BAAA;EACA,mCAAA;ACrER;ADwEI;EACI,6BAAA;EACA,kCAAA;ACtER;ADyEI;EACI,kBAAA;ACvER;AD0EI;EACI,2BAAA;EACA,uBAAA;ACxER;;AD4EA,8EAAA;AACA;;EAEI,YAAA;EACA,+BAAA;ACzEJ;;AD4EA;EACI,SAAA;ACzEJ;;AD4EA;EACI,kBAAA;ACzEJ;;AD4EA;EACI,iBAAA;ACzEJ;;AD4EA,yDAAA;AAEA;EACI,4BAAA;AC1EJ;;AD6EA;EACI,yBAAA;AC1EJ;;AD6EA;EACI,0BAAA;AC1EJ;;AD6EA;EACI,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,wBAAA;EACA,yBAAA;EACA,WAAA;AC1EJ;AD4EI;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,8BAAA;EACA,mCAAA;EACA,UAAA;EACA,+BAAA;EACA,qBAAA;AC1ER;;AD8EA;EACI;IACI,0BAAA;IACA,UAAA;EC3EN;ED8EE;IACI,UAAA;EC5EN;ED+EE;IACI,0BAAA;IACA,UAAA;EC7EN;AACF;ADgFA;EACI;IACI,UAAA;IACA,6CAAA;EC9EN;EDiFE;IACI,UAAA;IACA,0CAAA;EC/EN;EDkFE;IACI,2CAAA;EChFN;EDmFE;IACI,uCAAA;ECjFN;AACF;ADoFA;EACI,gBAAA;EACA,8EAAA;EACA,+CAAA;EACA,uBAAA;EACA,4BAAA;EACA,6BAAA;AClFJ;;ADqFA;EACI,6BAAA;EACA,uBAAA;EACA,mBAAA;EACA,+CAAA;EACA,6BAAA;AClFJ;;ADqFA;EACE,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;AClFF;;AC7hBA;;EAAA;AAUA;;+EAAA;AAoBA;;EAAA;AC9CA;EACI,WAAA;EACA,eAAA;AFyjBJ;AEvjBI;EACI,wBAAA;AFyjBR;AEtjBI;EDYA,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;AD6iBJ;AExjBI;EACI,yBAAA;AF0jBR;AEvjBI;EACI,qCAAA;AFyjBR;AEtjBI;EACI,0BAAA;AFwjBR;AErjBI;EACI,kBAAA;AFujBR;AEpjBI;EACI,eAAA;AFsjBR;AEnjBI;EACI,2BAAA;EACA,8BAAA;EACA,6BAAA;EACA,mBAAA;AFqjBR;AEjjBI;EACI,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,qBAAA;EACA,+BAAA;EACA,0BAAA;EACA,kCAAA;EACA,mBAAA;EACA,uBAAA;AFmjBR;AEjjBQ;EACI,wBAAA;AFmjBZ;AEhjBQ;EACI,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,0BAAA;EACA,gCAAA;EACA,wDAAA;EACA,qBAAA;EACA,0BAAA;AFkjBZ;AE7iBI;;;;EAKI,0BAAA;EACA,kCAAA;AF8iBR;AE5iBQ;;;;EACI,oCAAA;EACA,4CAAA;AFijBZ;AE7iBI;EACI,iCAAA;EACA,qBAAA;AF+iBR;AE5iBI;EACI,wDAAA;EACA,0BAAA;EACA,gCAAA;EACA,6BAAA;EACA,oBAAA;AF8iBR;AE3iBI;EACI,wCAAA;AF6iBR;AE1iBI;EACI,sBAAA;AF4iBR;;AEviBI;EACI,uCAAA;AF0iBR;AEviBI;EACI,uCAAA;AFyiBR;AEtiBI;EACI,qBAAA;AFwiBR;;AEjiBA;EACI,mCAAA;EACA,qDAAA;AFoiBJ;;AEhiBI;EACI,2BAAA;EACA,8BAAA;EACA,6BAAA;EACA,mBAAA;AFmiBR;AEjiBI;EACI,uCAAA;AFmiBR;AEhiBQ;EACI,uCAAA;EACA,mCAAA;AFkiBZ;;AE3hBQ;EACI,uBAAA;AF8hBZ;AE5hBY;EACI,0BAAA;EACA,gCAAA;AF8hBhB;AE7hBgB;EACI,0BAAA;AF+hBpB;AEvhBY;EACI,YAAA;AFyhBhB;AEvhBgB;EACI,qBAAA;AFyhBpB;AEnhBI;EACI,uBAAA;AFqhBR;;AE5gBI;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,kFAAA;EACA,kCAAA;EACA,0CAAA;EACA,qBAAA;AF+gBR;AE5gBI;;EAEI,qBAAA;EACA,oCAAA;EACA,4CAAA;AF8gBR;;AErgBI;EACI,wBAAA;AFwgBR;AErgBI;EACI,0BAAA;EACA,4BAAA;EACA,8BAAA;AFugBR;AEngBQ;EACI,yBAAA;EACA,2CAAA;AFqgBZ;AElgBQ;;EAEI,uCAAA;AFogBZ;;AE3fA;EACI,gBAAA;EACA,8EAAA;EACA,gHAAA;EACA,6BAAA;AF8fJ;;AErfI;EAGI,8CAAA;AFsfR;AEnfI;EACI,0DAAA;AFqfR;AEhfI;EACI,0DAAA;AFkfR;AE/eI;EACI,WAAA;AFifR;;AEzeA;EACI,wBAAA;AF4eJ;AE1eI;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AF4eR;AEzeI;EACI,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,UAAA;EACA,wBAAA;AF2eR;AEzeQ;EACI,WAAA;EACA,YAAA;AF2eZ;AExeQ;EACI,WAAA;EACA,YAAA;AF0eZ;AEveQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,uCAAA;AFyeZ;AEveY;EACI,SAAA;EACA,SAAA;AFyehB;AEvegB;EACI,iCAAA;EACA,qCAAA;AFyepB;AEreY;EACI,UAAA;EACA,2CAAA;AFuehB;AEleQ;;;EAGI,2CAAA;AFoeZ;AEheI;EACI,2CAAA;AFkeR;;AE1dA;EACI,kCAAA;AF6dJ;AE3dI;EACI,gCAAA;EACA,gCAAA;AF6dR;AEzdQ;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;AF2dZ;AExdQ;EACI,mBAAA;EACA,gCAAA;AF0dZ;AErdY;;EAEI,uCAAA;AFudhB;AEhdY;;;;EAEI,uCAAA;AFodhB;AE/cI;EACI,kBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AFidR;AE9cI;EACI,4CAAA;AFgdR;;AExcI;EACI,QAAA;AF2cR;AExcI;EACI,WAAA;EACA,YAAA;AF0cR;AEvcI;EACI,wBAAA;AFycR;AEtcI;EACI,eAAA;EACA,iBAAA;AFwcR;;AEhcA;EACI,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;AFmcJ;AEjcI;EAGI,8CAAA;AFicR;AE9bI;EACI,0DAAA;AFgcR;AE7bI;EACI,0DAAA;AF+bR;AE5bI;EACI,WAAA;AF8bR;;AEtbA;EDhbI,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EC+aA,wBAAA;EACA,0DAAA;EACA,6BAAA;EACA,oCAAA;AF4bJ;;AErbA;EACI,2BAAA;ED7bA,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;ADs3BJ;;AEvbI;EACI,8CAAA;AF0bR;;AGx5BA;EACE,gBAAA;AH25BF;;AGx5BA;EACE,kBAAA;AH25BF;;AGx5BA;EACE,wBAAA;AH25BF;;AGx5BA;EACE,kBAAA;AH25BF;;AGx5BA;EACE,aAAA;AH25BF;;AGx5BA;;EAEE,gBAAA;AH25BF;;AGx5BA;EACE,iBAAA;AH25BF;;AGx5BA;EACE,iBAAA;AH25BF;;AGx5BA;EACE,qBAAA,EAAA,4BAAA;EACA,2CAAA;AH25BF;;AGx5BA;EACE,2CAAA,EAAA,4BAAA;AH25BF;;AGx5BA;EACE,uCAAA,EAAA,0BAAA;AH25BF;;AGx5BA;EACE,wBAAA;EACA,yBAAA;EACA,qBAAA;EACA,8BAAA;AH25BF;;AGx5BA;EACE,0BAAA;EACA,4BAAA;AH25BF;;AGx5BA;EACE,uBAAA;EACA,kDAAA;EACA,sCAAA;AH25BF;;AGx5BA;EACE,iDAAA;AH25BF;;AGx5BA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oCAAA;AH25BF;;AGz5BA;EACE,6BAAA;AH45BF;;AAv+BA;EACE,0BAAA;EACA,UAAA;EACA,oBAAA;AA0+BF;;AAv+BA;EACE,iBAAA;EACA,WAAA;EACA,aAAA;AA0+BF;;AAv+BA;EACE,WAAA;EACA,iBAAA;AA0+BF;;AAv+BA;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;EI0GA,yHAAA;AJi4BF;;AAv+BA;EACE,qBAAA;AA0+BF;;AAv+BA;EACE,sCAAA;EACA,aAAA;EACA,qBAAA;AA0+BF;;AAv+BA;EACE,yBAAA;EACA,mBAAA;AA0+BF;;AAv+BA;EACE,mCAAA;EACA,wBAAA;AA0+BF;;AAv+BA;EACE,aAAA;AA0+BF","sourcesContent":["html,\nbody {\n    margin: 0;\n    font-family: lato;\n    height: 100%;\n    -webkit-overflow-scrolling: touch;\n\n    * {\n        outline: none;\n        --mat-stepper-container-text-font: 'Lato';\n        --mat-expansion-container-text-color: var(--text);\n        --mat-stepper-header-selected-state-icon-foreground-color: #fff;\n        --mat-stepper-header-selected-state-label-text-color: var(--text);\n        --mat-stepper-header-selected-state-icon-background-color: var(--primary);\n        --mat-stepper-header-icon-background-color: #0000008a;\n        --mat-stepper-header-icon-foreground-color: #fff;\n        --mat-stepper-header-label-text-color: rgba(0, 0, 0, 0.54);\n        --mdc-filled-text-field-label-text-color: rgba(0, 0, 0, 0.42);\n        --mdc-filled-text-field-input-text-color: rgba(0, 0, 0, 0.42);\n        --mdc-filled-text-field-error-label-text-color: var(--danger);\n        --mat-sys-on-error-container: var(--danger);\n        --mdc-filled-text-field-hover-label-text-color: rgba(0, 0, 0, 0.42);\n        --mdc-filled-text-field-error-hover-label-text-color: rgba(0, 0, 0, 0.42);\n        --mdc-filled-text-field-input-text-placeholder-color: rgba(0, 0, 0, 0.42);\n        --md-sys-typescale-body-medium-font-size: 14px;\n        --md-sys-typescale-label-large-font-size: 14px;\n        --mdc-text-button-hover-state-layer-color: var(--primary-hover);\n        --mat-text-button-pressed-state-layer-opacity: 0.1;\n        --mat-text-button-hover-state-layer-opacity:0.1;\n        --mat-expansion-container-shape: 4px;\n        --mat-sys-body-medium-size: 14px !important;\n        --mat-expansion-container-text-size: 14px !important;\n    }\n}\n\nbody::-webkit-scrollbar,\n.mat-mdc-select-panel::-webkit-scrollbar,\n::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n    transition: height 0.15s ease-out;\n}\n\nbody::-webkit-scrollbar-track,\n.mat-mdc-select-panel::-webkit-scrollbar-track,\n::-webkit-scrollbar-track {\n    -webkit-border-radius: 10px;\n    border-radius: 10px;\n}\n\nbody::-webkit-scrollbar-thumb,\n.mat-mdc-select-panel::-webkit-scrollbar-thumb,\n::-webkit-scrollbar-thumb {\n    -webkit-border-radius: 10px;\n    opacity: 0.1;\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.3);\n    box-shadow: rgba(255, 255, 255, 0.3) 0 0 0 1px;\n}\n\nbody:hover::-webkit-scrollbar,\n.mat-mdc-select-panel:hover::-webkit-scrollbar {\n    height: 0.6em;\n    transition: height 0.25s ease-in;\n}\n\nbody:hover::-webkit-scrollbar-thumb,\n.mat-mdc-select-panel:hover::-webkit-scrollbar-thumb {\n    -webkit-border-radius: 10px;\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.3);\n    box-shadow: rgba(255, 255, 255, 0.3) 0 0 0 1px;\n}\n\nbody::-webkit-scrollbar-thumb:hover,\n.mat-mdc-select-panel::-webkit-scrollbar-thumb:hover {\n    opacity: 1;\n    background: rgba(0, 0, 0, 0.55);\n}\n\nfooter {\n    small {\n        font-size: 0.7rem;\n        text-transform: uppercase;\n    }\n}\n\n.overflow-hidden {\n    overflow: hidden;\n}\n\n.resize .border {\n    position: absolute;\n    background: red;\n}\n\n.resize .border-top,\n.resize .border-bottom {\n    left: 0;\n    right: 0;\n    height: 1px;\n    cursor: n-resize;\n}\n\n.resize .border-left,\n.resize .border-right {\n    top: 0;\n    bottom: 0;\n    width: 1px;\n    cursor: w-resize;\n}\n\n.resize .border-left {\n    left: 0;\n}\n\n.resize .border-right {\n    right: 0;\n}\n\n.resize .border-top {\n    top: 0;\n}\n\n.resize .border-bottom {\n    bottom: 0;\n}\n\n.resize .border-top-left {\n    left: 0;\n    top: 0;\n    height: 4px;\n    width: 4px;\n    background: transparent !important;\n    cursor: se-resize;\n    z-index: 999;\n}\n\n.resize .border-top-right {\n    right: 0;\n    top: 0;\n    height: 4px;\n    width: 4px;\n    background: transparent !important;\n    cursor: ne-resize;\n    z-index: 999;\n}\n\n.resize .border-bottom-left {\n    left: 0;\n    bottom: 0;\n    height: 4px;\n    width: 4px;\n    background: transparent !important;\n    cursor: ne-resize;\n    z-index: 999;\n}\n\n.resize .border-bottom-right {\n    right: 0;\n    bottom: 0;\n    height: 4px;\n    width: 4px;\n    background: transparent !important;\n    cursor: se-resize;\n    z-index: 999;\n}\n\n.cdk-global-overlay-wrapper {\n    position: absolute;\n    top: 0;\n    left: 0;\n    // opacity: 0.75;\n}\n\n// ends\n\n.export-modal-container {\n    max-width: 85vw !important;\n    .mat-mdc-mdc-dialog-container {\n        padding: 0px !important;\n        overflow: hidden;\n    }\n}\n\nngx-daterangepicker-material {\n    & {\n        .md-drppicker {\n            td.active, .md-drppicker td.active:hover {\n                background-color: var(--primary) !important;\n            }\n            \n            padding: 10px !important;\n            font-family: var(--font-family) !important;\n            font-size: 1em !important;\n            max-width: 640px;\n\n            .table-condensed {\n                border-spacing: 0px;\n            }\n\n            th.month {\n                text-transform: uppercase;\n                color: var(--text);\n                font-size: 14px;\n            }\n\n            &.double {\n                .calendar {\n                    max-width: 295px !important;\n\n                    th.available.prev,\n                    th.available.next {\n                        background: none;\n                        position: relative;\n                        vertical-align: middle;\n                        line-height: 30px;\n\n                        &::before {\n                            font-family: \"Font Awesome 5 Free\";\n                            content: \"\\f104\";\n                            position: absolute;\n                            color: var(--primary);\n                            vertical-align: middle;\n                            top: 50%;\n                            transform: translateY(-50%);\n                            height: 100%;\n                            font-size: 1.3em;\n                            text-align: center;\n                        }\n                    }\n\n                    &.left {\n                        border-right: 1px solid var(--line);\n                    }\n\n                    td,\n                    th {\n                        border-radius: 0px !important;\n                        min-width: 40px;\n                        height: 30px;\n                    }\n\n                    td {\n                        span {\n                            padding: 0px;\n                            color: inherit;\n                            font-size: 13px;\n                            font-weight: 550 !important;\n                        }\n\n                        &.available:not(.active) {\n                            &:hover {\n                                background-color: rgba(var(--primary-rgb), 0.2) !important;\n                            }\n                           \n                        }\n                        &.available:not(.off) {\n                            color: var(--text);\n                        }\n\n                        &::hover {\n                            border-radius: 0px !important;\n                        }\n\n                        &.in-range {\n                            background-color: rgba(var(--primary-rgb), 0.2) !important;\n                            border-radius: 0px !important;\n                            color: var(--text) !important;\n                        }\n\n                        &.active {\n                            background-color: var(--primary) !important;\n                            border-radius: 0px !important;\n                            color: var(--white-color) !important;\n                        }\n                    }\n\n                    th {\n                        span {\n                            padding: 0px;\n                        }\n\n                        &.available:not(.active):not(.prev):not(.next) {\n                            &:hover {\n                                background-color: rgba(var(--primary-rgb), 0.2) !important;\n                            }\n                        }\n\n                        &::hover {\n                            border-radius: 0px !important;\n                        }\n                    }\n                }\n            }\n\n            .start-date,\n            .end-date,\n            .in-range {\n                color: var(--white-color) !important;\n\n                span {\n                    opacity: 1 !important;\n                }\n            }\n\n            .btn {\n                color: var(--primary) !important;\n                box-shadow: none !important;\n                background: transparent !important;\n                margin: 0;\n                min-width: auto;\n                line-height: 25px !important;\n                width: 80px;\n            }\n\n            .btn.btn-default::after {\n                content: \"|\";\n                color: gray;\n                font-size: 19px;\n                line-height: 0px;\n                margin-left: 13px;\n                position: relative;\n                top: -1px;\n            }\n\n            display: flex;\n            flex-flow: row;\n            flex-wrap: wrap;\n\n            .ranges {\n                order: 3;\n                float: none;\n                flex: 1 0 100%;\n                display: flex;\n                ul {\n                    margin: 7px 0;\n                    li:first-child::before {\n                        color: var(--text);\n                    }\n                    li {\n                        margin: 0px 5px;\n                        display: inline-block;\n\n                        &:hover {\n                            background: transparent;\n                            border-radius: 16px;\n                        }\n\n                        button {\n                            padding: 6px 10px;\n                            background: #f2f2f2;\n                            border-radius: 16px;\n                            color: #333;\n                            font-size: 12px;\n\n                            &.active {\n                                background-color: var(--primary);\n                            }\n                        }\n\n                        &:first-child {\n                            padding-left: 75px;\n                            vertical-align: middle;\n                            position: relative;\n\n                            &::before {\n                                content: \"Quick Select\";\n                                display: block;\n                                position: absolute;\n                                left: 0;\n                                top: 50%;\n                                transform: translateY(-50%);\n                            }\n                        }\n                    }\n                }\n            }\n\n            .calendar.left,\n            .calendar.right {\n                order: 1;\n            }\n\n            .buttons {\n                order: 4;\n                flex: 1 0 100%;\n\n                display: flex;\n                justify-content: flex-end;\n                align-items: center;\n            }\n\n            .btn {\n                line-height: 24px !important;\n                cursor: pointer;\n                &.clear svg {\n                    width: 16px;\n                    height: 16px;\n                }\n\n                &:hover {\n                    background-color: rgba(var(--primary-rgb), 0.1) !important;\n                }\n            }\n\n            &.double {\n                .calendar {\n                    td {\n                        &.active {\n                            background-color: var(--primary) !important;\n                            border-radius: 0px !important;\n                            color: #fff !important;\n\n                            &.off {\n                                background-color: #fff !important;\n                                border-color: transparent !important;\n                                color: #999 !important;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.mat-mdc-form-field.mat-mdc-focused .mat-mdc-select-arrow {\n    transform: rotate(-135deg) !important;\n}\n\n.mat-mdc-select-search-clear {\n    top: 10px;\n    background: transparent;\n    border: none;\n    line-height: 24px;\n}\n\n.mat-mdc-select-panel {\n    position: absolute;\n    top: 5px;\n    left: 0px;\n    font-size: 13px;\n    font-weight: 400;\n    border-radius: 3px !important;\n    border-top-style: none;\n}\n\n.mat-mdc-form-field-appearance-outline .mat-mdc-form-field-outline-start {\n    border-radius: 0px !important;\n    border-right-style: none !important;\n}\n\n.mat-mdc-form-field-appearance-outline .mat-mdc-form-field-outline-end {\n    border-radius: 0px !important;\n    border-left-style: none !important;\n}\n\n.mat-mdc-select-panel ng-animating {\n    visibility: hidden;\n}\n\n.mat-mdc-select-search-panel {\n    .mat-mdc-option {\n        height: 30px !important;\n        line-height: 30px !important;\n    }\n}\n\n.sort-order-dialog .mat-mdc-mdc-dialog-container {\n    padding: 0 !important;\n    overflow: unset !important;\n}\n\n.select-dropdown {\n    mat-form-field {\n        .mat-mdc-form-field-wrapper {\n            padding-bottom: 0 !important;\n        }\n\n        .mat-mdc-form-field-infix {\n            border-top: none !important;\n        }\n\n        .mat-mdc-form-field-ripple {\n            background-color: var(--primary);\n            height: 1px;\n        }\n\n        .mat-mdc-form-field-underline {\n            bottom: 0.25em !important;\n        }\n\n        .cross-icon {\n            font-size: 14px !important;\n            color: rgba(0, 0, 0, 0.54);\n        }\n    }\n\n    .mat-mdc-select-panel {\n        font-size: 13px;\n        font-weight: 400;\n        border-radius: 3px !important;\n        border-top-style: none;\n    }\n\n\n    .mat-mdc-select-placeholder {\n        color: rgba(0, 0, 0, 0.87);\n    }\n\n    .mat-mdc-form-field-appearance-outline .mat-mdc-form-field-outline-start {\n        border-radius: 0px !important;\n        border-right-style: none !important;\n    }\n\n    .mat-mdc-form-field-appearance-outline .mat-mdc-form-field-outline-end {\n        border-radius: 0px !important;\n        border-left-style: none !important;\n    }\n\n    .mat-mdc-select-panel ng-animating {\n        visibility: hidden;\n    }\n\n    .mat-mdc-option {\n        min-height: 30px !important;\n        height: 30px !important;\n    }\n}\n\n/* You can add global styles to this file, and also import other style files */\nhtml,\nbody {\n    height: 100%;\n    font-family: \"Lato\", sans-serif;\n}\n\nbody {\n    margin: 0;\n}\n\n.content {\n    position: relative;\n}\n\n.line {\n    stroke-width: 1px;\n}\n\n/*********************** Common CSS *********************/\n\n.text-light {\n    color: rgba(51, 51, 51, 0.6);\n}\n\n.text-uppercase {\n    text-transform: uppercase;\n}\n\n.capitalize {\n    text-transform: capitalize;\n}\n\n.pulse {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 50%;\n    height: 14px;\n    width: 14px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    margin: 9px 0px 0px -8px;\n    transform: rotateX(55deg);\n    z-index: -2;\n\n    &:after {\n        content: \"\";\n        border-radius: 50%;\n        height: 40px;\n        width: 40px;\n        position: absolute;\n        margin: -13px 0 0 -13px;\n        animation: pulsate 1s ease-out;\n        animation-iteration-count: infinite;\n        opacity: 0;\n        box-shadow: 0 0 1px 2px #89849b;\n        animation-delay: 1.1s;\n    }\n}\n\n@keyframes pulsate {\n    0% {\n        transform: scale(0.1, 0.1);\n        opacity: 0;\n    }\n\n    50% {\n        opacity: 1;\n    }\n\n    100% {\n        transform: scale(1.2, 1.2);\n        opacity: 0;\n    }\n}\n\n@keyframes bounce {\n    0% {\n        opacity: 0;\n        transform: translateY(-2000px) rotate(-45deg);\n    }\n\n    60% {\n        opacity: 1;\n        transform: translateY(30px) rotate(-45deg);\n    }\n\n    80% {\n        transform: translateY(-10px) rotate(-45deg);\n    }\n\n    100% {\n        transform: translateY(0) rotate(-45deg);\n    }\n}\n\n.site-selection-dropdown-panel {\n    overflow: hidden;\n    background-color: var(--mat-select-panel-background-color, var(--white-color));\n    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.24);\n    width: 376px !important;\n    max-height: 360px !important;\n    border-radius: 4px !important;\n}\n\n.site-selection-dropdown-sort-menu {\n    position: relative !important;\n    right: 162px !important;\n    top: 5px !important;\n    background-color: var(--white-color) !important;\n    border-radius: 4px !important;\n}\n\n.site-selection-dropdown-empty {\n  font-family: Lato !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  line-height: 16px !important;\n}","@use '@angular/material' as mat;\n@use 'src/styles.scss' as *;\n\n.table-container {\n  margin: 20px 20px 0px 20px;\n  width: 98%;\n  padding-bottom: 10px;\n}\n\n.table-action-container {\n  margin-top: -12px;\n  width: 100%;\n  display: flex;\n}\n\n.paginator-box {\n  width: 100%;\n  text-align: right;\n}\n\n.table {\n  max-height: calc(100vh - 220px);\n  overflow: auto;\n  border-radius: 5px;\n  @include mat.elevation(1);\n}\n\n.no-padding {\n  padding: 0 !important;\n}\n\n.action-icon {\n  color: var(--primary-light) !important;\n  margin: 0 4px;\n  transform: scale(.7);\n}\n\n.action-icon.disabled {\n  color: #d6d6d6 !important;\n  cursor: not-allowed;\n}\n\n.action-icon.clickable:hover {\n  color: rgb(226, 129, 87) !important;\n  transition: .1s ease-in;\n}\n\n.hidden {\n  display: none;\n}","//Common mixin which can be used for styling of the font with respect to the font-size, font-weight and line-height\n@mixin common-font-style($font-size, $font-weight, $line-height) {\n    font-family: Lato;\n    font-weight: $font-weight;\n    font-size: $font-size;\n    line-height: $line-height;\n    color: #333333;\n}\n\n//Common mixin which can be used to wrap the text with respect to the max-width\n@mixin common-text-wrap($max-width) {\n    max-width: $max-width;\n    text-wrap: auto;\n    white-space: normal;\n    word-break: break-all;\n}\n\n// Truncates text with an ellipsis while preserving a fixed maximum width, often used with tooltips.\n@mixin common-text-truncate-tootltip($max-width) {\n    max-width: $max-width;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap !important;\n}\n\n/**\n * Sets a consistent typography baseline with the Lato font and overridable size, line height, and weight.\n */\n@mixin text-style($font-size, $line-height, $font-weight: 400) {\n    font-family: Lato !important;\n    font-size: $font-size !important;\n    font-weight: $font-weight !important;\n    line-height: $line-height !important;\n}\n\n/* ==========================================================================\n   Text Utilities\n   ========================================================================== */\n\n// Wraps text within a maximum width and breaks long words when needed to avoid overflow.\n@mixin text-wrap($max-width) {\n    max-width: $max-width;\n    white-space: normal;\n    overflow-wrap: break-word;\n    word-break: break-word;\n}\n\n// Truncates single-line text with an ellipsis when it exceeds the available width.\n@mixin text-truncate($max-width) {\n    max-width: $max-width;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\n/**\n * Applies the shared icon color and opacity behavior, including a stronger hover state.\n */\n@mixin icon-style($color: var(--primary),\n    $opacity: 0.5,\n    $hover-opacity: 1) {\n    color: $color;\n    opacity: $opacity;\n\n    &:hover {\n        opacity: $hover-opacity;\n    }\n}\n","@use './mixins' as *;\n\n// =============================================================================\n// COMMON MATERIAL OVERRIDES\n// -----------------------------------------------------------------------------\n\n// -----------------------------------------------------------------------------\n// SELECT TRIGGER\n// -----------------------------------------------------------------------------\n.app-mat-form-field-trigger {\n    width: 100%;\n    cursor: pointer;\n\n    .mat-mdc-form-field-subscript-wrapper {\n        display: none !important;\n    }\n\n    .mat-mdc-text-field-wrapper .mat-mdc-select-placeholder {\n        @include text-style(14px, 16px);\n    }\n\n    .mat-mdc-select-value {\n        color: #333333 !important;\n    }\n\n    .mat-mdc-select-placeholder {\n        color: var(--lighter-grey) !important;\n    }\n\n    &.mat-mdc-select-disabled .mat-mdc-select-value {\n        color: rgba(0, 0, 0, 0.38);\n    }\n\n    .mat-mdc-select-arrow-wrapper {\n        padding-right: 3px;\n    }\n\n    .mdc-text-field__input {\n        cursor: pointer;\n    }\n\n    .mat-mdc-form-field-infix {\n        padding-top: 1px !important;\n        padding-bottom: 4px !important;\n        position: relative !important;\n        top: 6px !important;  \n    }\n\n    // Custom chevron matching FontAwesome fa-chevron-down used in site-selection-dropdown\n    .mat-mdc-select-arrow {\n        box-sizing: border-box;\n        border: none !important;\n        width: auto !important;\n        height: auto !important;\n        margin-right: 1px;\n        color: var(--primary);\n        display: inline-flex !important;\n        transform: none !important;\n        -webkit-transform: none !important;\n        align-items: center;\n        justify-content: center;\n\n        svg {\n            display: none !important;\n        }\n\n        &::after {\n            content: \"\\f078\";\n            font-family: \"Font Awesome 5 Free\";\n            font-weight: 900;\n            font-size: 12px !important;\n            color: var(--primary) !important;\n            text-shadow: 0.3px 0 currentColor, -0.3px 0 currentColor;\n            display: inline-block;\n            transform: none !important;\n        }\n    }\n\n    // Flip the chevron to point up while the field is focused/open\n    &.mat-focused .mat-mdc-select-arrow,\n    &.mat-mdc-focused .mat-mdc-select-arrow,\n    .mat-mdc-select[aria-expanded=\"true\"] .mat-mdc-select-arrow,\n    .mat-select[aria-expanded=\"true\"] .mat-mdc-select-arrow,\n    .mat-mdc-select-panel-open .mat-mdc-select-arrow {\n        transform: none !important;\n        -webkit-transform: none !important;\n\n        &::after {\n            transform: rotate(180deg) !important;\n            -webkit-transform: rotate(180deg) !important;\n        }\n    }\n\n    .mat-mdc-select-panel {\n        background-color: #fff !important;\n        padding: 0 !important;\n    }\n\n    .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix i {\n        text-shadow: 0.3px 0 currentColor, -0.3px 0 currentColor;\n        font-size: 12px !important;\n        color: var(--primary) !important;\n        position: relative !important;\n        left: 6px !important;\n    }\n\n    .mat-mdc-icon-button:hover:not([disabled]) {\n        background-color: transparent !important;\n    }\n\n    .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {\n        bottom: 2px !important;\n    }\n}\n\n.app-mat-form-field-trigger-open {\n    .mat-mdc-text-field-wrapper .mdc-line-ripple::before {\n        border-bottom-color: #333333 !important;\n    }\n\n    .mat-mdc-text-field-wrapper .mdc-line-ripple::after {\n        border-bottom-color: #333333 !important;\n    }\n\n    .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {\n        opacity: 1 !important;\n    }\n}\n\n// -----------------------------------------------------------------------------\n// SEARCH FIELD — shared search field styles for dropdowns and other components\n// -----------------------------------------------------------------------------\n.app-mat-form-search-field.mat-focused .mat-mdc-input-element::placeholder {\n    color: var(--light-grey) !important;\n    -webkit-text-fill-color: var(--light-grey) !important;\n}\n\n.app-mat-form-search-field {\n    .mat-mdc-form-field-infix {\n        padding-top: 1px !important;\n        padding-bottom: 4px !important;\n        position: relative !important;\n        top: 3px !important;\n    }\n    .mdc-line-ripple::before {\n        border-bottom-color: #B6B6B6 !important;\n    }\n    &.mat-focused {\n        .mdc-line-ripple::after {\n            border-bottom-color: #333333 !important;\n            border-bottom-width: 1px !important;\n        }\n    }\n}\n\n.app-mat-form-search-field.mat-mdc-form-field {\n    .mat-mdc-form-field-flex {\n        .mat-mdc-form-field-icon-suffix {\n            opacity: 0.5 !important;\n\n            i {\n                font-size: 14px !important;\n                color: var(--primary) !important;\n                &:hover {\n                    cursor: pointer !important;\n                }\n            }\n        }\n    }\n\n    &.mat-focused {\n        .mat-mdc-form-field-flex {\n            .mat-mdc-form-field-icon-suffix {\n                opacity: 0.5;\n\n                &:hover {\n                    opacity: 1 !important;\n                }\n            }\n        }\n    }\n\n    .mat-mdc-form-field-icon-prefix {\n        padding: 0px !important;\n    }\n}\n\n\n// -----------------------------------------------------------------------------\n// SELECT TRIGGER — custom arrow icon for select triggers\n// -----------------------------------------------------------------------------\n.app-select-trigger--svg-arrow {\n    .mat-mdc-select-arrow {\n        width: 100%;\n        height: 100%;\n        border: 0 !important;\n        opacity: 0.5;\n        background: url('/assets/images/chevronarrow.svg') no-repeat center center / contain;\n        transform: rotate(0deg) !important;\n        -webkit-transform: rotate(0deg) !important;\n        padding: 0 !important;\n    }\n\n    &.mat-focused .mat-mdc-select-arrow,\n    .mat-mdc-select[aria-activedescendant] .mat-mdc-select-arrow {\n        opacity: 1 !important;\n        transform: rotate(180deg) !important;\n        -webkit-transform: rotate(180deg) !important;\n    }\n}\n\n\n// -----------------------------------------------------------------------------\n// FORM FIELD — shared subscript/placeholder/focused-underline behavior\n// -----------------------------------------------------------------------------\n.app-form-field {\n    .mat-mdc-form-field-subscript-wrapper {\n        display: none !important;\n    }\n\n    .mat-mdc-text-field-wrapper .mat-mdc-select-placeholder {\n        font-size: 14px !important;\n        line-height: 16px !important;\n        font-family: 'Lato' !important;\n    }\n\n    &.mat-focused {\n        .mat-mdc-text-field-wrapper .mat-mdc-select-placeholder {\n            color: #333333 !important;\n            -webkit-text-fill-color: #333333 !important;\n        }\n\n        .mdc-line-ripple::before,\n        .mdc-line-ripple::after {\n            border-bottom-color: #333333 !important;\n        }\n    }\n}\n\n\n// -----------------------------------------------------------------------------\n// SELECT / AUTOCOMPLETE PANEL — dropdown container chrome\n// -----------------------------------------------------------------------------\n.app-select-panel {\n    overflow: hidden;\n    background-color: var(--mat-select-panel-background-color, var(--white-color));\n    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);\n    border-radius: 4px !important;\n}\n\n\n// -----------------------------------------------------------------------------\n// OPTION — hover / selected / focused states for options inside a panel\n// -----------------------------------------------------------------------------\n.app-option {\n\n    &:hover:not(.mat-mdc-option-disabled):not(.app-option-selected),\n    &:focus:not(.mat-mdc-option-disabled),\n    &.mdc-list-item--selected:not(.mat-mdc-option-disabled) {\n        background-color: var(--hover-grey) !important;\n    }\n\n    &.mdc-list-item--selected:not(.mdc-list-item--disabled):not(.mat-mdc-option-multiple) {\n        background-color: rgba(var(--primary-rgb), 0.1) !important;\n    }\n\n    // Apply app-option-selected yourself when you track selection outside\n    // Angular Material's own state (e.g. a custom multi-select row)\n    &.app-option-selected:hover {\n        background-color: rgba(var(--primary-rgb), 0.1) !important;\n    }\n\n    .mdc-list-item__primary-text {\n        width: 100%;\n    }\n}\n\n\n// -----------------------------------------------------------------------------\n// CHECKBOX — compact 14x14 box, primary-colored border/fill\n// -----------------------------------------------------------------------------\n.app-checkbox {\n    display: flex !important;\n\n    .mdc-form-field>label {\n        padding-left: 12px;\n        font-weight: 400;\n        white-space: nowrap;\n        color: var(--strong-text);\n    }\n\n    .mdc-checkbox {\n        width: 14px !important;\n        height: 14px !important;\n        flex: 0 0 14px;\n        padding: 0;\n        margin-top: 0 !important;\n\n        .mat-mdc-checkbox-touch-target {\n            width: 14px;\n            height: 14px;\n        }\n\n        input.mdc-checkbox__native-control {\n            width: 100%;\n            height: 100%;\n        }\n\n        .mdc-checkbox__background {\n            position: relative;\n            top: 0;\n            left: 0;\n            width: 14px !important;\n            height: 14px !important;\n            border: 1px solid;\n            border-color: var(--primary) !important;\n\n            .mdc-checkbox__checkmark {\n                top: -1px;\n                left: 1px;\n\n                .mdc-checkbox__checkmark-path {\n                    stroke-dashoffset: 6px !important;\n                    stroke: var(--white-color) !important;\n                }\n            }\n\n            .mdc-checkbox__mixedmark {\n                width: 75%;\n                border-color: var(--white-color) !important;\n            }\n        }\n\n        // Checked / indeterminate fill\n        .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,\n        .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,\n        .mdc-checkbox__native-control[data-indeterminate=\"true\"]:enabled~.mdc-checkbox__background {\n            background-color: var(--primary) !important;\n        }\n    }\n\n    &.mat-mdc-checkbox-checked .mdc-checkbox .mdc-checkbox__background {\n        background-color: var(--primary) !important;\n    }\n}\n\n\n// -----------------------------------------------------------------------------\n// RADIO — compact 14x14 circle, primary-colored ring/fill\n// -----------------------------------------------------------------------------\n.app-radio {\n    --mdc-radio-state-layer-size: 20px;\n\n    .mat-internal-form-field {\n        align-items: baseline !important;\n        vertical-align: unset !important;\n    }\n\n    .mdc-radio {\n        .mdc-radio__background {\n            position: relative;\n            top: 3.5px;\n            left: 2px;\n            height: 14px;\n            width: 14px;\n        }\n\n        .mdc-radio__inner-circle {\n            border-width: unset;\n            background-color: var(--primary);\n        }\n\n        .mdc-radio__native-control:enabled+.mdc-radio__background {\n\n            .mdc-radio__outer-circle,\n            .mdc-radio__inner-circle {\n                border-color: var(--primary) !important;\n            }\n        }\n\n        .mdc-radio__native-control:enabled:focus+.mdc-radio__background,\n        .mdc-radio__native-control:enabled:active+.mdc-radio__background {\n\n            .mdc-radio__outer-circle,\n            .mdc-radio__inner-circle {\n                border-color: var(--primary) !important;\n            }\n        }\n    }\n\n    .mdc-label {\n        position: relative;\n        top: 2px;\n        padding-left: 0;\n        font-size: 12px;\n        color: #333333;\n    }\n\n    &.mat-mdc-radio-disabled .mdc-radio__inner-circle {\n        background-color: var(--mid-gray) !important;\n    }\n}\n\n// Modifier: compact radio for tight contexts like menu items — hides the\n// ripple and tightens the label gap. Apply alongside app-radio:\n//   <mat-radio-button class=\"app-radio app-radio--compact\">\n.app-radio--compact {\n    .mdc-form-field {\n        gap: 5px;\n    }\n\n    .mat-mdc-radio-touch-target {\n        width: 100%;\n        height: 100%;\n    }\n\n    .mat-radio-ripple {\n        display: none !important;\n    }\n\n    .mdc-label {\n        font-size: 14px;\n        line-height: 16px;\n    }\n}\n\n\n// -----------------------------------------------------------------------------\n// Mat Select panel options — hover / selected / focused states for options inside a panel\n// -----------------------------------------------------------------------------\n.app-dropdown-mat-options {\n    padding: 0px 12px !important;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-height: 28px;\n    cursor: pointer;\n\n    &:hover:not(.mat-mdc-option-disabled):not(.site-selection-dropdown-option-selected),\n    &:focus:not(.mat-mdc-option-disabled),\n    &.mdc-list-item--selected:not(.mat-mdc-option-disabled) {\n        background-color: var(--hover-grey) !important;\n    }\n\n    &.mdc-list-item--selected:not(.mdc-list-item--disabled):not(.mat-mdc-option-multiple) {\n        background-color: rgba(var(--primary-rgb), 0.1) !important;\n    }\n\n    &.site-selection-dropdown-option-selected:hover {\n        background-color: rgba(var(--primary-rgb), 0.1) !important;\n    }\n\n    .mdc-list-item__primary-text {\n        width: 100%;\n    }\n}\n\n\n// -----------------------------------------------------------------------------\n// Mat tooltip — override default tooltip styles for better legibility and contrast\n// -----------------------------------------------------------------------------\n.app-mat-tooltip-text {\n    @include text-style(12px, 14px);\n    padding: 10px !important;\n    background-color: var(--tooltip-background-rgb) !important;\n    border-radius: 4px !important;\n    color: var(--white-color) !important;\n}\n\n\n// -----------------------------------------------------------------------------\n// Menu item — override default menu item styles for better legibility and contrast\n// -----------------------------------------------------------------------------\n.app-menu-item {\n    min-height: 28px !important;\n    @include text-style(14px, 16px);\n}\n\n.app-menu-item.app-menu-item {\n    &:not([disabled]):hover {\n        background-color: var(--hover-grey) !important;\n    }\n}","@use \"src/assets/css/styles.scss\" as *;\n@use \"src/assets/css/common-material-styles.scss\" as *;\nhtml {\n  overflow: hidden;\n}\n\n.center {\n  text-align: center;\n}\n\n.flex {\n  display: flex !important;\n}\n\n.relative {\n  position: relative;\n}\n\n.hidden {\n  display: none;\n}\n\n.scroll-max-400,\n.scroll-max-300 {\n  overflow-y: auto;\n}\n\n.scroll-max-300 {\n  max-height: 300px;\n}\n\n.scroll-max-400 {\n  max-height: 400px;\n}\n\n.mat-mdc-radio-button.mat-accent .mat-mdc-radio-ripple .mat-mdc-ripple-element {\n  opacity: 0 !important; /*click effect color change*/\n  background-color: var(--primary) !important;\n}\n  \n.mat-mdc-radio-button.mat-mdc-accent .mat-mdc-radio-inner-circle {\n  background-color: var(--primary) !important; /*inner circle color change*/\n}\n  \n.mat-mdc-radio-button.mat-mdc-accent.mat-mdc-radio-checked .mat-mdc-radio-outer-circle {\n  border-color: var(--primary) !important; /*outer ring color change*/\n}\n\n.daterangepicker {\n  z-index: 1050 !important; // higher than mat-dialog (usually 1000+)\n  display: block !important;\n  opacity: 1 !important;\n  visibility: visible !important;\n}\n\n.mdc-text-field {\n  overflow: unset !important;\n  will-change: auto !important;\n}\n\n.mat-mdc-button {\n  height: 36px !important;\n  --mdc-text-button-label-text-color : var(--primary);\n  justify-content: flex-start !important;\n}\n\n.cdk-overlay-pane.mat-mdc-dialog-panel {\n  --mat-dialog-container-max-width: 100% !important;\n}\n\n.mat-mdc-select-value-text {\n  font-size: 14px;\n  font-weight: 400;\n  font-family: 'Lato';\n  color: var(--text);\n  -webkit-text-fill-color: var(--text);\n}\n.gtranslate_wrapper {\n  visibility: hidden !important;\n}\n","@use 'sass:map';\n@use 'sass:math';\n@use 'sass:meta';\n@use 'sass:string';\n@use './variables';\n@use './sass-utils';\n\n$_umbra-opacity: 0.2;\n$_penumbra-opacity: 0.14;\n$_ambient-opacity: 0.12;\n\n$_umbra-map: (\n  0: '0px 0px 0px 0px',\n  1: '0px 2px 1px -1px',\n  2: '0px 3px 1px -2px',\n  3: '0px 3px 3px -2px',\n  4: '0px 2px 4px -1px',\n  5: '0px 3px 5px -1px',\n  6: '0px 3px 5px -1px',\n  7: '0px 4px 5px -2px',\n  8: '0px 5px 5px -3px',\n  9: '0px 5px 6px -3px',\n  10: '0px 6px 6px -3px',\n  11: '0px 6px 7px -4px',\n  12: '0px 7px 8px -4px',\n  13: '0px 7px 8px -4px',\n  14: '0px 7px 9px -4px',\n  15: '0px 8px 9px -5px',\n  16: '0px 8px 10px -5px',\n  17: '0px 8px 11px -5px',\n  18: '0px 9px 11px -5px',\n  19: '0px 9px 12px -6px',\n  20: '0px 10px 13px -6px',\n  21: '0px 10px 13px -6px',\n  22: '0px 10px 14px -6px',\n  23: '0px 11px 14px -7px',\n  24: '0px 11px 15px -7px',\n);\n\n$_penumbra-map: (\n  0: '0px 0px 0px 0px',\n  1: '0px 1px 1px 0px',\n  2: '0px 2px 2px 0px',\n  3: '0px 3px 4px 0px',\n  4: '0px 4px 5px 0px',\n  5: '0px 5px 8px 0px',\n  6: '0px 6px 10px 0px',\n  7: '0px 7px 10px 1px',\n  8: '0px 8px 10px 1px',\n  9: '0px 9px 12px 1px',\n  10: '0px 10px 14px 1px',\n  11: '0px 11px 15px 1px',\n  12: '0px 12px 17px 2px',\n  13: '0px 13px 19px 2px',\n  14: '0px 14px 21px 2px',\n  15: '0px 15px 22px 2px',\n  16: '0px 16px 24px 2px',\n  17: '0px 17px 26px 2px',\n  18: '0px 18px 28px 2px',\n  19: '0px 19px 29px 2px',\n  20: '0px 20px 31px 3px',\n  21: '0px 21px 33px 3px',\n  22: '0px 22px 35px 3px',\n  23: '0px 23px 36px 3px',\n  24: '0px 24px 38px 3px',\n);\n\n$_ambient-map: (\n  0: '0px 0px 0px 0px',\n  1: '0px 1px 3px 0px',\n  2: '0px 1px 5px 0px',\n  3: '0px 1px 8px 0px',\n  4: '0px 1px 10px 0px',\n  5: '0px 1px 14px 0px',\n  6: '0px 1px 18px 0px',\n  7: '0px 2px 16px 1px',\n  8: '0px 3px 14px 2px',\n  9: '0px 3px 16px 2px',\n  10: '0px 4px 18px 3px',\n  11: '0px 4px 20px 3px',\n  12: '0px 5px 22px 4px',\n  13: '0px 5px 24px 4px',\n  14: '0px 5px 26px 4px',\n  15: '0px 6px 28px 5px',\n  16: '0px 6px 30px 5px',\n  17: '0px 6px 32px 5px',\n  18: '0px 7px 34px 6px',\n  19: '0px 7px 36px 6px',\n  20: '0px 8px 38px 7px',\n  21: '0px 8px 40px 7px',\n  22: '0px 8px 42px 7px',\n  23: '0px 9px 44px 8px',\n  24: '0px 9px 46px 8px',\n);\n\n// A collection of mixins and CSS classes that can be used to apply elevation to a material\n// element.\n// See: https://material.io/design/environment/elevation.html\n// Examples:\n//\n//\n// .mat-foo {\n//   @include $mat-elevation(2);\n//\n//   &:active {\n//     @include $mat-elevation(8);\n//   }\n// }\n//\n// <div id=\"external-card\" class=\"mat-elevation-z2\"><p>Some content</p></div>\n//\n// For an explanation of the design behind how elevation is implemented, see the design doc at\n// https://docs.google.com/document/d/1W3NGSLqDZzjbBBLW2C6y_6NUxtvdZAVaJvg58LY3Q0E/edit\n\n// The default duration value for elevation transitions.\n$transition-duration: 280ms !default;\n\n// The default easing value for elevation transitions.\n$transition-timing-function: variables.$fast-out-slow-in-timing-function;\n\n// The default color for elevation shadows.\n$color: black !default;\n\n// Prefix for elevation-related selectors.\n$prefix: 'mat-elevation-z';\n\n// Applies the correct css rules to an element to give it the elevation specified by $zValue.\n// The $zValue must be between 0 and 24.\n@mixin elevation($zValue, $color: $color, $opacity: null) {\n  box-shadow: get-box-shadow($zValue, $color, $opacity);\n}\n\n// Applies the elevation to an element in a manner that allows\n// consumers to override it via the Material elevation classes.\n@mixin overridable-elevation($zValue, $color: $color, $opacity: null) {\n  &:not([class*='#{$prefix}']) {\n    @include elevation($zValue, $color, $opacity);\n  }\n}\n\n// Gets the box shadow value for a specific elevation.\n@function get-box-shadow($zValue, $shadow-color: black, $opacity: null) {\n  @if $zValue == null {\n    @return null;\n  }\n\n  @if (sass-utils.is-css-var-name($zValue)) {\n    @return $zValue;\n  }\n\n  @if meta.type-of($zValue) != number or not math.is-unitless($zValue) {\n    @error '$zValue must be a unitless number, but received `#{$zValue}`';\n  }\n\n  @if $zValue < 0 or $zValue > 24 {\n    @error '$zValue must be between 0 and 24, but received `#{$zValue}`';\n  }\n\n  $umbra-z-value: map.get($_umbra-map, $zValue);\n  $penumbra-z-value: map.get($_penumbra-map, $zValue);\n  $ambient-z-value: map.get($_ambient-map, $zValue);\n\n  $color-opacity: if($opacity != null, $opacity, 1);\n  $umbra-color: _compute-color-opacity($shadow-color, $_umbra-opacity * $color-opacity);\n  $penumbra-color: _compute-color-opacity($shadow-color, $_penumbra-opacity * $color-opacity);\n  $ambient-color: _compute-color-opacity($shadow-color, $_ambient-opacity * $color-opacity);\n\n  @return string.unquote('#{$umbra-z-value} #{$umbra-color}, #{$penumbra-z-value} ' +\n          '#{$penumbra-color}, #{$ambient-z-value} #{$ambient-color}');\n}\n\n// Returns a string that can be used as the value for a transition property for elevation.\n// Calling this function directly is useful in situations where a component needs to transition\n// more than one property.\n//\n// .foo {\n//   transition: mat-elevation-transition-property-value(), opacity 100ms ease;\n// }\n@function private-transition-property-value(\n    $duration: $transition-duration,\n    $easing: $transition-timing-function) {\n  @return box-shadow #{$duration} #{$easing};\n}\n\n// Applies the correct css rules needed to have an element transition between elevations.\n// This mixin should be applied to elements whose elevation values will change depending on their\n// context (e.g. when active or disabled).\n//\n// NOTE(traviskaufman): Both this mixin and the above function use default parameters so they can\n// be used in the same way by clients.\n@mixin elevation-transition(\n    $duration: $transition-duration,\n    $easing: $transition-timing-function) {\n  transition: private-transition-property-value($duration, $easing);\n}\n\n@function _compute-color-opacity($color, $opacity) {\n  @if meta.type-of($color) == color and $opacity != null {\n    @return rgba($color, $opacity);\n  }\n  @else {\n    @return $color;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
